export function isNodeVersion(version: number) {
  const nodeMajorVersion = parseInt(process.version.slice(1).split('.')[0], 10);
  return nodeMajorVersion === version;
}
